export const formatPhoneNumber = (phoneNumberString) => {
  if (!phoneNumberString) {
    return ''
  }
  const cleaned = ('' + phoneNumberString).replace(/\D/g, '')
  const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
  if (match) {
    const intlCode = match[1] ? '+1 ' : ''
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('')
  }
  return formatUkPhone(phoneNumberString)
}

const formats = [
  {
    EXAMPLE: '01### #####',
    pattern: /^01/,
    format: [5, null],
  },
  {
    EXAMPLE: '011# ### ####',
    pattern: /^011/,
    format: [4, 3, null],
  },
  {
    EXAMPLE: '01#1 ### ####',
    pattern: /^01\d1/,
    format: [4, 3, null],
  },
  {
    EXAMPLE: '013873 #####',
    pattern: /^013873/,
    format: [6, null],
  },
  {
    EXAMPLE: '015242 #####',
    pattern: /^015242/,
    format: [6, null],
  },
  {
    EXAMPLE: '015394 #####',
    pattern: /^015394/,
    format: [6, null],
  },
  {
    EXAMPLE: '015395 #####',
    pattern: /^015395/,
    format: [6, null],
  },
  {
    EXAMPLE: '015396 #####',
    pattern: /^015396/,
    format: [6, null],
  },
  {
    EXAMPLE: '016973 #####',
    pattern: /^016973/,
    format: [6, null],
  },
  {
    EXAMPLE: '016974 #####',
    pattern: /^016974/,
    format: [6, null],
  },
  {
    EXAMPLE: '016977 ####',
    pattern: /^016977/,
    format: [6, null],
  },
  {
    EXAMPLE: '017683 #####',
    pattern: /^017683/,
    format: [6, null],
  },
  {
    EXAMPLE: '017684 #####',
    pattern: /^017684/,
    format: [6, null],
  },
  {
    EXAMPLE: '017687 #####',
    pattern: /^017687/,
    format: [6, null],
  },
  {
    EXAMPLE: '019467 #####',
    pattern: /^019467/,
    format: [6, null],
  },
  {
    EXAMPLE: '02# #### ####',
    pattern: /^02/,
    format: [3, 4, null],
  },
  {
    EXAMPLE: '03## ### ####',
    pattern: /^03/,
    format: [4, 3, null],
  },
  {
    EXAMPLE: '05### ######',
    pattern: /^05/,
    format: [5, null],
  },
  {
    EXAMPLE: '07### ######',
    pattern: /^07/,
    format: [5, null],
  },
  {
    EXAMPLE: '08## ### ####',
    pattern: /^08/,
    format: [4, 3, null],
  },
  {
    EXAMPLE: '0800 ######',
    pattern: /^0800/,
    format: [4, null],
  },
  {
    EXAMPLE: '09## ### ####',
    pattern: /^09/,
    format: [4, 3, null],
  },
  {
    EXAMPLE: '+44 ## #### ####',
    pattern: /^44/,
    format: [2, 2, 4, null],
    prefix: '+',
  },
  {
    EXAMPLE: '+44 ## #### ####',
    pattern: /^0044/,
    format: [2, 2, 4, null],
    prefix: '+',
    skip: 2,
  },
]

const formatValue = (value, fmt) => {
  const { format, prefix, skip } = fmt
  const phone = skip ? value.substr(skip, value.length) : value
  let formatted = ''

  let startIndex = 0
  for (let i = 0; i < format.length; i++) {
    const length = format[i] === null ? phone.length : format[i]
    formatted += `${phone.substr(startIndex, length)} `
    startIndex += length
  }

  formatted = `${prefix || ''}${formatted}`
  return formatted.trim()
}

const formatUkPhone = (value) => {
  const phone = value.replace(' ', '')
  const results = formats.map((fmt) => ({
    match: fmt.pattern.test(value),
    value: formatValue(phone, fmt),
  }))
  const matches = results.filter((f) => f.match)
  return matches && matches.length ? matches[matches.length - 1].value : value
}
